import { useLanguage } from '../../../hooks/useLanguage';
import { useProduct } from '../../../hooks/useProduct';
import { X } from 'lucide-react';

const content = {
  en: {
    title: 'WHERE TO FIND US',
    subtitle: '🚀 Seoul Vibes, Just Around the Corner!',
    description:
      "Korean Street is landing everywhere in Europe in your favorite supermarket! We bring Seoul to your plate. Korean Street is available throughout France, Germany and UK. Can't find Korean Street? Write to us!",
  },
  fr: {
    title: 'OÙ NOUS TROUVER?',
    subtitle: '🚀 Seoul Vibes, à deux pas de chez vous !',
    description:
      'Korean Street débarque partout en Europe dans votre grande surface préférée ! On amène Seoul dans votre assiette. Korean Street est disponible dans toute la France dans vos magasins Carrefour ou Monoprix. Vous ne trouvez pas Korean Street ? Ecrivez nous !',
  },
};

const desktopMapImage = `${
  import.meta.env.VITE_CLOUDFRONT_URL
}/website_KOST_sales_map_desktop.png`;

// const mobileMapImage = `${
//   import.meta.env.VITE_CLOUDFRONT_URL
// }/website_KOST_sales_map_mobile.png`;

export default function WhereToFind() {
  const { language } = useLanguage();
  const { setActiveNavPanel } = useProduct();
  const data = content[language];
  return (
    <div className="min-h-full bg-yellow-400 relative">
      {/* Close Button - Mobile Only */}
      <button
        onClick={() => setActiveNavPanel(null)}
        className="lg:hidden absolute top-4 right-4 z-50"
      >
        <X className="w-8 h-8 text-white" />
      </button>

      {/* Title */}
      <div className="px-4 md:px-6 pt-6 md:pt-8 pb-4">
        <h1 className="text-5xl md:text-7xl font-black text-white tracking-tight leading-tight">
          {language === 'en' ? 'WHERE' : 'OÙ'}
        </h1>
        <h1 className="text-5xl md:text-7xl font-black text-white tracking-tight leading-tight">
          {language === 'en' ? 'TO FIND US' : 'NOUS TROUVER'}
        </h1>
      </div>

      {/* Map */}
      <div className="px-4 md:px-6 mb-6">
        <div className="rounded-2xl overflow-hidden shadow-xl w-full max-w-6xl mx-auto">
          <img src={desktopMapImage} style={{ border: '0' }} />
        </div>
      </div>

      {/* Description */}
      <div className="px-4 md:px-6 pb-20 lg:pb-6">
        <div className="bg-white rounded-xl p-6 shadow-lg border-4 border-yellow-500">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            {data.subtitle}
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            {data.description}
          </p>
        </div>
      </div>
    </div>
  );
}
